import styled from 'styled-components';

// Slider Settings
export const settings = {
    dots: true,
    infinite: false,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    arrows: false,
    useCSS: true,
    cssEase: 'cubic-bezier(.42,0,.58,1)',
};

/**
 *  Dynamic Slider Colors (NM)
 **/

// WorkSlider - container/parent div.
export const WorkSlider = styled.div`
    background-color: ${props => props.bgColor || '#00ebd2'};
    .slick-dots {
        li {
            button {
                &:before {
                    color: ${props => props.dotColor || '#00ebd2'};
                }
            }
        }
    }
`;

// Slide "h2" title.
export const Title = styled.h2`
    color: ${props => props.textColor || '#FFF'} !important;
`;

// Slide "Buttons" color.
export const SlideButton = styled.button`
    background-color: ${props => props.buttonColor || '#FFF'};
    &:hover {
        background-color: ${props => props.buttonHoverColor || '#000'};
        .icon {
            color: ${props => props.iconHoverColor || '#666'} !important;
        }
    }
`;

export const Icon = styled.i`
    color: ${props => props.iconColor || '#666'} !important;
`;



// WEBPACK FOOTER //
// ./src/components/Pages/Work/slider-settings/index.jsx